<template>
    <div class="electronic_invoice_wrapper">
        <div class="order_item">
            <div class="title_class">保单号</div>
            <div class="value_class">14527003900840351967</div>
        </div>
        <div class="price_item">
            <div class="title_class">发票金额（保费）</div>
            <div class="value_class">216.00</div>
        </div>


        <div class="company_container">
            <div class="detail_item">发票详情</div>
            <div class="invoice_type">
                <div class="title_class">发票类型</div>
                <div class="value_class">电子普通发票</div>
            </div>
            <div class="title_type">
                <div class="title_class">发票类型</div>
                <van-radio-group v-model="radio" direction="horizontal" icon-size='0.3rem' checked-color="#28CC77">
                    <van-radio name="0">企业</van-radio>
                    <van-radio name="1">个人</van-radio>
                </van-radio-group>
            </div>
            <div class="input_item">
                <div class="title_class">发票抬头:</div>
                <div class="value_class">
                    <input type="text" v-model="invoiceTitle" :placeholder="radio==1?'抬头名称，默认为“个人”':'填写公司发票抬头'" placeholder-class="title" class="input_class">
                </div>
            </div>
            <div v-if="radio==0" class="input_item">
                <div class="title_class">公司税号:</div>
                <div class="value_class">
                    <input type="number" v-model="taxNumber" placeholder="填写纳税人识别号" placeholder-class="title" class="input_class">
                </div>
            </div>
            <div class="input_item">
                <div class="title_class">电子邮箱:</div>
                <div class="value_class">
                        <input type="email" v-model="email" placeholder="用于向您发送电子邮件" placeholder-class="title" class="input_class">
                </div>
            </div>
            <div class="input_item">
                <div class="title_class">手机号码:</div>
                <div class="value_class">
                    <input type="tel" v-model="tel" placeholder="请填写手机号" placeholder-class="title" class="input_class">
                </div>
            </div>
        </div>
        <div class="btn">确认开票</div>
    </div>
</template>

<script>
import './ElectronicInvoice.less';
import Vue from 'vue';
import { RadioGroup, Radio } from 'vant';

export default {
    name: "ElectronicInvoice",
    data(){
        return{
            radio: '1',
            invoiceTitle: '',
            taxNumber: '',
            email: '',
            tel: ''
        }
    },
    components: {
        'van-radio': Radio ,
        'van-radio-group': RadioGroup
    },
    methods: {

    }
}
</script>

<style>

</style>